import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import arrIcon from "../../../images/svg/jobList/arr4.svg"
import { useState } from "react"
import moment from "moment"
import formatConverter from "../../../helper/formatConverter"
import fiyatlandirmaTipOptions from "../../../utils/yukOptions/fiyatlandirmaTipOptions"
import priceReverseCalculator from "../../../helper/priceReverseCalculator"
import { handleFrameState, setAracBekleyenYukCheckedItem } from "../../../features/joblist/jobListSlice"
import { useDispatch } from "react-redux"
import konum1 from "../../../images/svg/jobList/konum1.svg"
import konum2 from "../../../images/svg/jobList/konum2.svg"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { BsCheck } from "react-icons/bs";
import { useNavigate } from "react-router-dom"


const Container = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${({theme}) => theme.mainTextColor};


    .topp-container{
        width: 100%;
        margin-bottom: 5px;

        h2{
            text-align: center;
            font-size: var(--font-size-xl);
            font-weight: var(--font-weight-xl);
        }
    }

    .content-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 3px solid ${({theme}) => theme.mainBorderColor};
        padding: 5px;
        border-radius: 10px;
        position: relative;

        .arr-btn{
            position: absolute;
            top: 0;
            left: 0;
        }


        .content-top-container{
            width: 100%;
            margin-top: 20px;
        }

        .main-content{
            width: 100%;
            display: flex;
            flex-direction: column;

            .content-list{
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }
`

const ContentItem = styled.div`
    width: 100%;
    padding:  10px;
    padding-bottom: 25px;
    border: 2px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 10px;
    position: relative;
    display: flex;
    background-color: ${({theme, isChecked}) => isChecked ? "rgba(250, 136, 136, 0.1)" : theme.mainBgColor};

    .column-item{
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-right: auto;

        &:first-child{
            margin-right: 5px;
        }

        .item-title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
            display: flex;
            align-items: center;
            gap: 5px;
            text-decoration: underline;
        }

        .checkbox{
            width: 20px;
            height: 20px;
            border-radius: 4px;
            border: 1px solid ${({theme, isChecked}) => !isChecked ? theme.mainTextColor : "none"};
            background-color: ${({theme, isChecked}) => isChecked ? "var(--color-main)" : theme.secondaryBgColor};
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            .check-icon{
                font-size: 2.6rem;
                color: #fff;
            }
        }      

    
        .item-data{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;
            align-items: center;
            gap: 5px;
        }

        .konum-container{
            display: flex;
            flex-direction: column;
            gap: 2px;
      
      .konum-item{
        display: flex;
        flex-direction: column;
        gap: 2px;

        div{
          padding-left: 15px;
        }

        .sm-data{
          font-size: 12px;
        }


        .dashed{
          border-left: 1px dashed${({theme}) => theme.mainTextColor};
        }
        
      }

      .item-location{
        position: relative;

        img{
          position: absolute;
          top: 2px;
          left: -7px;
          width: 15px;
        }

      }
    }

    .sm-konum-container{
      display: flex;
      gap: 5px;

      .konum-side{
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;

        .img{
          width: 12px;
        }

        .line{
          border-left: 1px dashed ${({theme}) => theme.mainTextColor};
          height: 15px;
        }
      }

      .data-side{
        display: flex;
        flex-direction: column;
        gap: 5px;

        .item-location{
          padding-bottom: 2px;
        }
      }
    }
    }

    .colored{
        color: var(--color-main);
        font-weight: var(--font-weight-lg);
      }

      .inner{
        padding-top: 5px;
        padding-left: 15px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
      }

    .column-item:nth-child(1){
        width: 5%;
    }
    .column-item:nth-child(2){
        width: 20%;
    }
    .column-item:nth-child(3){
        width: 30%;
    }
    .column-item:nth-child(4){
        width: 20%;
    }
    .column-item:nth-child(5){
        width: 25%;
    }

    .more-btn{
        font-size: 10px;
        font-weight: var(--font-weight-md);
        color: ${({theme, isOpened}) => isOpened ? "var(--color-main)" : theme.secondaryTextColor};
        position: absolute;
        bottom: 4px;
        right: 6px;
        cursor: pointer;
    }

`



const EqualYukSide = ({loadList, isLoading, checkedItem}) => {

    const [isOpenedItemId, setIsOpenedItemId] = useState(null)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    // if(loadList.length < 1){
    //     return "boş burası"
    // }

  return (
    <Container>
        <div className="topp-container">
            <h2>Araç Bekleyen Yükler</h2>
        </div>
        <div className="content-container">
            <button className="arr-btn" onClick={() => dispatch(handleFrameState("yukSide"))}>
                <img src={arrIcon} alt="" />
            </button>
            <div className="content-top-container">
                <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"220px"} handleClick={() => navigate("/yuk-ekle")}>+ Yeni Yük Ekle</Btn>
            </div>
            <div className="main-content">
            {
                isLoading ? <SmallSpinner size={"50px"} color={"#fff"} bgColor={"#E85446"}/>  
                    :
                <div className="content-list">
                    {
                        loadList.map(item => {
                            if(item.id === isOpenedItemId){
                                return (
                                     <ContentItem isOpened={item.id === isOpenedItemId} isChecked={item?.id === checkedItem?.id}>
                                     <div className="column-item">
                                        <button className="checkbox" onMouseDown={() => dispatch(setAracBekleyenYukCheckedItem(item?.id !== checkedItem?.id ? item : null ))} onTouchStart={() => dispatch(setAracBekleyenYukCheckedItem(item?.id !== checkedItem?.id ? item : null ))} onClick={() => dispatch(setAracBekleyenYukCheckedItem(item?.id !== checkedItem?.id ? item : null ))}>
                                            {
                                                item?.id === checkedItem?.id &&
                                                <BsCheck className="check-icon"/>
                                            }
                                        </button>
                                     </div>
                                     <div className="column-item">
                                         <div className="item-title">Talep Detayı</div>
                                         <div className="item-data">{item.id}</div>
                                         <div className="item-data">{item.truckType}/{item.trailerType}</div>
                                         <div className="item-data">{item.truckQuantity} Araç</div>
                                         <div className="item-data">{moment(item?.routePoints?.$values[0]?.loadDate)?.format("DD.MM.YYYY")} - {item.routePoints.$values[0].loadTime}</div>
                                     </div>
                                     <div className="column-item">
                                     <div className="row-grp row-grp-location">
                                            <div className="item-title underline">Nereden - Nereye</div>
                                              <div className="konum-container">
                                                <div className="konum-item">
                                                    <div className="item-location colored">{item.routePoints.$values[0].location}
                                                      <img src={konum1} alt="" />
                                                    </div>
                                                    <div className="sm-data dashed">{moment(item?.routePoints?.$values[0]?.loadDate)?.format("DD.MM.YYYY")} - {item.routePoints.$values[0].loadTime}</div>
                                                    <div className="sm-data dashed">Rampadan-Forklift var</div>
                                                </div>

                                                <div className="konum-item">
                                                    <div className="item-location colored border-none">{item.routePoints.$values[item?.routePoints?.$values.length -1].location}
                                                      <img src={konum2} alt="" />
                                                    </div>
                                                      <div className="sm-data border-none">{moment(item?.routePoints?.$values[item?.routePoints?.$values.length -1]?.loadDate)?.format("DD.MM.YYYY")} - {item.routePoints.$values[item?.routePoints?.$values.length - 1].loadTime}</div>
                                                    <div className="sm-data">Rampadan-Forklift var</div>
                                                </div>
                                                <div className="inner">{item.distance} Km {item.routePoints.$values.length > 2 && `- ${(item.routePoints.$values.length -2)} Durak`}</div>
                                          </div>
                                        </div>
                                     </div>
                                     <div className="column-item">
                                         <div className="item-title">Yük</div>
                                         <div className="item-data">{item.loadType}</div>
                                         <div className="item-data"></div>
                                         <div className="item-data">{item.isParsiyel ? "Parsiyel" : "Komple"}</div>
                                         <div className="item-data">{item.loadQuantity} {item.loadUnit}</div>
                                         {/* <div className="item-data">{item.packingingTypes.$values}</div> */}
                                     </div>
                                     <div className="column-item">
                                         <div className="item-title">Ödeme</div>
                                         <div className="item-data">{formatConverter(item.freight, 0)} + {fiyatlandirmaTipOptions.find(innerItem=> innerItem.value === item.paymentUnit)?.text} + KDV</div>
                                         <div className="item-data">{item.paymentType}</div>
                                         {
                                            item.commissionPaymentId !== 0 &&
                                            <div className="item-data">Komisyon {item.commissionPaymentId === 1 ? `%${item.commissionPayment}` : item.commissionPaymentId === 2 && `${item.commissionPayment} TL`} - {item.commissionPaymentId === 1 ? `${formatConverter(priceReverseCalculator(item.freight, item.commissionPaymentId, item.commissionPayment), 0)} TL` : item.commissionPaymentId === 2 && `%${formatConverter(priceReverseCalculator(item.freight, item.commissionPaymentId, item.commissionPayment), 0)}`}</div>
                                         }
                                         {
                                            item?.aspiredLoads?.$values?.length > 0 &&
                                            <div className="item-data">{item?.aspiredLoads?.$values?.length} Teklif</div>
                                         }
                                        {
                                            item?.aspiredLoads?.$values?.length > 0 &&
                                            <div className="item-data">
                                                {
                                                    item?.aspiredLoads?.$values?.length > 1 &&
                                                    "En Düşük Teklif " 
                                                }
                                                {formatConverter(
                                                    item?.aspiredLoads?.$values?.reduce((min, item) =>
                                                    item.offerValue < min.offerValue ? item : min
                                                    )?.offerValue,
                                                    0
                                                )} TL
                                            </div>
                                        }

                                     </div>
                                     <button className="more-btn" onClick={() => setIsOpenedItemId(null)}>Detaylar kapat</button>
                                 </ContentItem>
                                )
                            }
                            else{
                                return (
                                    <ContentItem isChecked={item?.id === checkedItem?.id}>
                                        <div className="column-item">
                                            <div className="checkbox" onClick={() => dispatch(setAracBekleyenYukCheckedItem(item?.id !== checkedItem?.id ? item : null ))}>
                                                {
                                                    item?.id === checkedItem?.id &&
                                                    <BsCheck className="check-icon"/>
                                                }
                                            </div>
                                        </div>
                                        <div className="column-item">
                                            <div className="item-title">Talep Detayı</div>
                                            <div className="item-data">{item.id}</div>
                                            <div className="item-data">{item.truckType}/{item.trailerType}</div>
                                        </div>
                                        <div className="column-item">
                                            <div className="item-title">Nereden - Nereye</div>
                                            <div className="sm-konum-container">
                                          <div className="konum-side">
                                            <img src={konum1} className="img" alt="Nereden" />
                                            <div className="line"></div>
                                            <img src={konum2} className="img" alt="Nereden" />
                                          </div>
                                          <div className="data-side">
                                            <div className="item-location colored border-none">{item.routePoints.$values[0].location}</div>
                                            <div className="item-location colored border-none">{item.routePoints.$values[item?.routePoints?.$values.length -1].location}</div>
                                          </div>

                                        </div>
                                        </div>
                                        <div className="column-item">
                                         <div className="item-title">Yük</div>
                                         <div className="item-data colored">{item.loadType}</div>
                                         <div className="item-data"></div>
                                     </div>
                                     <div className="column-item">
                                         <div className="item-title">Ödeme</div>
                                         <div className="item-data colored">{formatConverter(item.freight, 0)} + {fiyatlandirmaTipOptions.find(innerItem=> innerItem.value === item.paymentUnit)?.text} + KDV</div>
                                         {
                                            item?.aspiredLoads?.$values?.length > 0 &&
                                            <div className="item-data">{item?.aspiredLoads?.$values?.length} Teklif - {formatConverter(
                                                item?.aspiredLoads?.$values?.reduce((min, item) =>
                                                item.offerValue < min.offerValue ? item : min
                                                )?.offerValue,
                                                0
                                            )} TL</div>
                                         }

                                     </div>
                                        <button className="more-btn" onClick={() => setIsOpenedItemId(item.id)}>Detaylar için tıklayın</button>
                                    </ContentItem>
                                )

                            }
                        })
                    }
                </div>
                }
            </div>

        </div>
    </Container>
  )
}

export default EqualYukSide